import React from 'react'
import { SvgIcon } from '@mui/material'


export const CloseOutlinedIcon = ({ sx, ...props }) => {
    return (
        <SvgIcon width="21" height="21" viewBox="0 0 21 21" {...{ sx: sx?.color ? { ...sx, stroke: sx.color } : sx, ...props }}>
            <g clip-path="url(#clip0_1513_3091)">
                <path d="M7.94033 7.1009C7.70845 6.86902 7.33251 6.86902 7.10064 7.1009C6.86877 7.33277 6.86877 7.70871 7.10064 7.94058L8.65997 9.49992L7.10066 11.0592C6.86878 11.2911 6.86878 11.667 7.10066 11.8989C7.33253 12.1308 7.70847 12.1308 7.94035 11.8989L9.49966 10.3396L11.059 11.8989C11.2908 12.1308 11.6668 12.1308 11.8986 11.8989C12.1305 11.667 12.1305 11.2911 11.8986 11.0592L10.3393 9.49992L11.8987 7.9406C12.1305 7.70873 12.1305 7.33279 11.8987 7.10091C11.6668 6.86904 11.2908 6.86904 11.059 7.10091L9.49966 8.66023L7.94033 7.1009Z" />
                <path fill-rule="evenodd" clip-rule="evenodd" d="M9.49967 0.989502C4.7995 0.989502 0.989258 4.79975 0.989258 9.49992C0.989258 14.2001 4.7995 18.0103 9.49967 18.0103C14.1998 18.0103 18.0101 14.2001 18.0101 9.49992C18.0101 4.79975 14.1998 0.989502 9.49967 0.989502ZM2.17676 9.49992C2.17676 5.45558 5.45534 2.177 9.49967 2.177C13.544 2.177 16.8226 5.45558 16.8226 9.49992C16.8226 13.5443 13.544 16.8228 9.49967 16.8228C5.45534 16.8228 2.17676 13.5443 2.17676 9.49992Z" />
            </g>
            <defs>
                <clipPath id="clip0_1513_3091">
                    <rect width="21" height="21" fill="white" />
                </clipPath>
            </defs>
        </SvgIcon>
    )
}
